import React from 'react'
import { Modal, Paper, Slide, Button, Box } from '@material-ui/core'

import { AuditValueStatus } from '../../types'
import { useAuditResultsDialogStyles } from './styles'
import { AuditResultsContent } from './AuditResultsContent'

interface AuditResultsDialogProps {
    open: boolean
    onClose: () => void
    rentRollFile: string | undefined
    rentRollCoordinates: string | null
    leaseDocumentFile: string
    documentPageNumber: number | null
    attributeName: string
    rentRollValue: string | null
    documentValue: string | null
    conflictValue?: string | null
    status: AuditValueStatus
    reviewNote?: string | null
    reviewNoteAuthor?: string | null
    onSaveReviewNote?: (note: string | null) => Promise<void> | void
    isSavingReviewNote?: boolean
    onUpdateDocumentValue?: (value: string | null) => Promise<void> | void
    isUpdatingDocumentValue?: boolean
}

export const AuditResultsDialog: React.FC<AuditResultsDialogProps> = ({
    open,
    onClose,
    rentRollFile,
    rentRollCoordinates,
    leaseDocumentFile,
    documentPageNumber,
    attributeName,
    rentRollValue,
    documentValue,
    conflictValue,
    status,
    reviewNote,
    reviewNoteAuthor,
    onSaveReviewNote,
    isSavingReviewNote = false,
    onUpdateDocumentValue,
    isUpdatingDocumentValue = false,
}) => {
    const classes = useAuditResultsDialogStyles()

    return (
        <Modal open={open} onClose={onClose} className={classes.modal}>
            <Slide direction="up" in={open}>
                <Paper className={classes.paper}>
                    <AuditResultsContent
                        attributeName={attributeName}
                        rentRollFile={rentRollFile}
                        rentRollCoordinates={rentRollCoordinates}
                        leaseDocumentFile={leaseDocumentFile}
                        documentPageNumber={documentPageNumber}
                        rentRollValue={rentRollValue}
                        documentValue={documentValue}
                        conflictValue={conflictValue}
                        status={status}
                        reviewNote={reviewNote}
                        reviewNoteAuthor={reviewNoteAuthor}
                        onSaveReviewNote={onSaveReviewNote}
                        isSavingReviewNote={isSavingReviewNote}
                        onUpdateDocumentValue={onUpdateDocumentValue}
                        isUpdatingDocumentValue={isUpdatingDocumentValue}
                    />

                    {/* Footer */}
                    <Box className={classes.footer}>
                        <Button
                            onClick={onClose}
                            variant="contained"
                            className={classes.darkButton}
                        >
                            Close
                        </Button>
                    </Box>
                </Paper>
            </Slide>
        </Modal>
    )
}
